export default "<rmd:editablesymptom>\n\t<div>\n\t\t<input type='text' data-id='text' data-property='value'></input>\n\t</div>\n</rmd:editablesymptom>";